import React, { Component } from "react";
import { Row, Col, CardBody, Card, Alert,Container,CustomInput } from "reactstrap";

// availity-reactstrap-validation
import { AvForm, AvField,AvInput } from "availity-reactstrap-validation";

// action
import { registerUser,apiError,registerUserFailed } from "../../store/actions";

// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// import images
import profileImg from "../../assets/images/profile-img.png";
import logoImg from "../../assets/images/mtlogo.png";

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  // handleValidSubmit
  handleValidSubmit(event, values) {
    this.props.registerUser(values);
  }

    componentDidMount()
    {
        this.props.apiError("");
        this.props.registerUserFailed("");
    }

  render() {
    return (
      <React.Fragment>
        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="bx bx-home h2"></i>
          </Link>
        </div>
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-soft-primary">
                    <Row>
                      <Col className="col-7">
                        <div className="text-primary p-4">
                          <h5 className="text-primary">Register</h5>
                          <p>Get your Moverstrip account now.</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profileImg} alt="" className="img-fluid" style={{maxWidth:'60%',float:'right'}} />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div>
                      <Link to="/">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logoImg}
                              alt=""
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="p-2">
                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={this.handleValidSubmit}
                      >
                        {this.props.user && this.props.user ? (
                          <Alert color="success">
                            Register User Successfully
                          </Alert>
                        ) : null}
                        {this.props.registrationError &&
                          this.props.registrationError ? (
                            <Alert color="danger">
                              {this.props.registrationError}
                            </Alert>
                          ) : null}

<div className="form-group">
                          <AvField
                            name="name"
                            label="Name"
                            className="form-control"
                            placeholder="Enter Name"
                            type="Text"
                            required
                          />
                        </div>
                        <div className="form-group">
                          <AvField
                            name="mobileno"
                            label="Mobile No"
                            type="Number"
                            required
                            placeholder="Enter Mobile Number"
                          />
                        </div>
                        <div className="form-group">
                          <AvField
                            name="email"
                            label="Email(Optional)"
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            
                          />
                        </div>
                        <div className="form-group">
                          <AvField
                            name="password"
                            label="Password"
                            type="password"
                            required
                            placeholder="Enter Password"
                          />
                        </div>
                        <div className="form-group">
                          <AvField
                            name="Confirm_password"
                            label="Confirm Password"
                            type="password"
                            required
                            placeholder="Enter Confirm Password"
                          />
                        </div>
                        <div className="mt-4 text-center">
                        <AvInput tag={CustomInput} type="checkbox" name="customCheckbox" required>
                        I agree to the <a href="#">Terms and Conditions</a> 
                          </AvInput>
                           
                        </div>
                        <div className="mt-4">
                          <Link to="otpVerification"
                            className="btn btn-primary btn-block waves-effect waves-light"
                            type="submit"
                          >
                            Register
                          </Link>
                        </div>

                       
                      </AvForm>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p>
                    Already have an account ?{" "}
                    <Link
                      to="/login"
                      className="font-weight-medium text-primary"
                    >
                      {" "}
                      Login
                    </Link>{" "}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = state => {
  const { user, registrationError, loading } = state.Account;
  return { user, registrationError, loading };
};

export default connect(mapStatetoProps, { registerUser,apiError,registerUserFailed })(Register);
